var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{staticClass:"ma-4",attrs:{"sentry-tag":"settings-debug.button.reindex"},on:{"click":_vm.reindex}},[_vm._v(" Reindex")]),_c('v-btn',{staticClass:"ma-4",attrs:{"sentry-tag":"settings-debug.button.reindexAll"},on:{"click":_vm.reindexAll}},[_vm._v(" Reindex All")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }